/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_3_AnswerInputs */

const en_svc_n8n_faq_3_answer = /** @type {(inputs: Svc_N8n_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. We start by reviewing what exists, document it, fix the fragile parts and then extend it.`)
};

const lv_svc_n8n_faq_3_answer = /** @type {(inputs: Svc_N8n_Faq_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Sākam ar esošā pārskatīšanu, to dokumentējam, salabojam trauslās vietas un tad paplašinām.`)
};

/**
* | output |
* | --- |
* | "Yes. We start by reviewing what exists, document it, fix the fragile parts and then extend it." |
*
* @param {Svc_N8n_Faq_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_3_answer = /** @type {((inputs?: Svc_N8n_Faq_3_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_3_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_3_answer(inputs)
	return en_svc_n8n_faq_3_answer(inputs)
});